import Table from '@utils/table'
import Template from './templates/default-template.vue'
class MultipleTable extends Table {
  static template = Template

  public _table = new Table()
  public _listProp?: string
  public _hideHead = true
  public _hideTableList = true

  table(table: Table) {
    this._table = table
    return this
  }

  hideHead(hideHead: boolean) {
    this._hideHead = hideHead
    return this
  }

  listProp(listProp: string) {
    this._listProp = listProp
    return this
  }

  hideTableList(hideTableList: boolean) {
    this._hideTableList = hideTableList
    return this
  }

  tpl(tpl?: any): any {
    // eslint-disable-next-line
    const $table = this
    const template = tpl || this._template || MultipleTable.template
    const mixins = this.mixins
    $table._table.injectList && $table._table.injectList($table._list || $table)
    const injectVueInstance = {
      beforeCreate() {
        $table.vm = this
      }
    }
    return { mixins: [injectVueInstance, mixins, template] }
  }
  getSettingColumn() {
    if (this._table) return this._table.getSettingColumn()
    return this.column
  }
}

export default MultipleTable
